import {AUTH_SUCCESS, AUTH_PERMISOS_SUCCESS, AUTH_LOGOUT} from '../actions/constants/auth.constants';
import getPayload from '../../helpers/jwt.helper';
const initialState = {
  token: null,
  user: null,
  permisos: null,
};

export default function authReducer(state = initialState, { type, payload }) {
  switch (type) {
    case AUTH_SUCCESS: {
      const { token, permisos } = payload;
      const userFromPayload = getPayload(token);
      localStorage.setItem('token', token);
      localStorage.setItem('moneda', permisos && permisos.configuracion && permisos.configuracion.moneda ? permisos.configuracion.moneda : '€');
      localStorage.setItem('digitos_moneda', permisos && permisos.configuracion && permisos.configuracion.moneda_digitos_decimales ? permisos.configuracion.moneda_digitos_decimales : '2');
      return {
        ...state, token, user: userFromPayload, permisos,
      };
    }
    case AUTH_PERMISOS_SUCCESS: {
      const { permisos } = payload;
      localStorage.setItem('moneda', permisos && permisos.configuracion && permisos.configuracion.moneda ? permisos.configuracion.moneda : '€');
      localStorage.setItem('digitos_moneda', permisos && permisos.configuracion && permisos.configuracion.moneda_digitos_decimales ? permisos.configuracion.moneda_digitos_decimales : '2');
      return {
        ...state,
        permisos,
      };
    }
    default:
      return state;
  }
}
